export enum AccessLevel {
  INTERNAL = "INTERNAL",
  PUBLIC = "PUBLIC",
  PUBLIC_IN_PRACTICE = "PUBLIC_IN_PRACTICE", // Used when search for a patient in practice (similar to PUBLIC)
  PATIENT = "PATIENT",
  PATIENT_UNAUTHENTICATED = "PATIENT_UNAUTHENTICATED",
  PATIENT_IN_PRACTICE = "PATIENT_IN_PRACTICE", // Used when a patient in practice has verified their details (similar to PATIENT_UNAUTHENTICATED)
  PATIENT_EXPIRED_SESSION = "PATIENT_EXPIRED_SESSION", // Used when a patient has an expired session (JWT is still valid but the session has expired in global-user-sessions table)
  PRACTICE_ADMIN = "PRACTICE_ADMIN",
}
